import { css } from "styled-components";

export const sellerTableColors = {
  header: "var(--admin-theme-raised, #f8f8f8)",
  text: "var(--admin-theme-muted, #555555)",
  border: "var(--admin-theme-border, #e5e7eb)",
  hover: "var(--admin-theme-raised, #fafafa)",
};

export const sellerTableHeader = css`
  box-sizing: border-box;
  min-height: 48px;
  height: 48px;
  background: ${sellerTableColors.header};
  color: ${sellerTableColors.text};
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  border-bottom: 1px solid ${sellerTableColors.border};
`;

export const sellerTableRow = css`
  box-sizing: border-box;
  min-height: 56px;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  border-bottom: 1px solid ${sellerTableColors.border};
`;

export const sellerTable = css`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  th { ${sellerTableHeader} padding: 0 16px; white-space: nowrap; }
  td { box-sizing: border-box; height: 56px; padding: 8px 16px; border-bottom: 1px solid ${sellerTableColors.border}; line-height: 1.5; }
  tbody tr:hover { background: ${sellerTableColors.hover}; }
  td[colspan] { height: 120px; text-align: center; color: ${sellerTableColors.text}; }
`;
